import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BonusCard } from './BonusCard';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusValue } from '../data/copy';
export function BonusesSection() {
  return <section id="bonuses" className="defer-paint w-full scroll-mt-6 border-t border-line bg-canvas py-12 sm:py-20" aria-labelledby="bonuses-heading" data-id="element-46" data-mp="vqjkr5xabcrk">
      <div className="mx-auto max-w-5xl px-5 sm:px-6" data-id="element-47" data-mp="14sj3q3rv0qx5">
        <SectionHeading eyebrow="Included — not sold separately" titleId="bonuses-heading" title={<>
              The <span className="text-gold-text" data-id="element-49" data-mp="1ej4awflln3ro">5 Command Kit</span> Bonuses
            </>} lead="Professional systems for the moments that matter most." data-id="element-48" data-mp="14r832ctpnza9" />

        <ul className="mt-8 grid items-start gap-3 sm:mt-12 md:grid-cols-2 md:gap-4" data-id="element-50" data-mp="19kt28871izb1">
          {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-51" data-mp="1nkbxi0er6g5x" />)}
        </ul>

        <div className="mx-auto mt-6 flex max-w-xl items-center gap-4 rounded-2xl border border-gold/60 bg-white px-5 py-4 sm:mt-10" data-id="element-52" data-mp="1jji790du8p9v">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold text-navy" aria-hidden="true" data-id="element-53" data-mp="3pseqkgs05sfv">
            <GiftIcon className="h-5 w-5" strokeWidth={2.25} data-id="element-54" data-mp="2lvtsl5csbo3" />
          </span>
          <div className="text-left" data-id="element-55" data-mp="2nytxy07zl6j">
            <p className="text-sm text-body" data-id="element-56" data-mp="7kz0ea0zepy6">
              Total bonus value{' '}
              <span className="font-semibold text-signal line-through" data-id="element-57" data-mp="ck1ytbmghxx6">
                {bonusValue}
              </span>
            </p>
            <p className="font-extrabold uppercase text-gold-text sm:text-lg" data-id="element-58" data-mp="gk2jvf4297d7">
              All 5 kits free today
            </p>
          </div>
        </div>
      </div>
    </section>;
}